import gql from 'graphql-tag'

export const fetchPlaceOrderMutation = gql`
mutation ($cart_id: String!, $use_budget: Int) {
    placeOrder(
        input: {
        cart_id: $cart_id
        use_budget: $use_budget
        }
    )
    {
        order {
            order_number
             customer_order_number
             note_for_driver
             sap_id
        }
    }
}

`
